import { h, Fragment } from "preact";
import { useEffect, useState } from "preact/hooks";

const sortDesigners = (followDesignerHandles, designersData) =>
  followDesignerHandles
    .map((followDesignerHandle) =>
      designersData.find(({ handle }) => {
        return followDesignerHandle === handle;
      })
    )
    .filter((item) => item)
    .sort((a, b) => a.name.localeCompare(b.name));

export default function DesignersChips({
  initialFollowDesigners,
  designersData,
}) {
  const [followDesigners, setFollowDesigners] = useState(
    initialFollowDesigners.map((designer) => designer.handle)
  );
  const [designers, setDesigners] = useState([]);

  useEffect(() => {
    const handleUpdate = (e) => {
      setFollowDesigners(e.detail.followDesigners);
    };

    document.addEventListener("follow-designers:updated", handleUpdate);

    return () =>
      document.removeEventListener("follow-designers:updated", handleUpdate);
  }, []);

  useEffect(() => {
    setDesigners(sortDesigners(followDesigners, designersData));
  }, [followDesigners, designersData]);

  return (
    <ul className="designers__chips">
      {designers.map((designer) => (
        <li className="designers__chip">
          <button
            type="button"
            className="designers__chip-button"
            onClick={() => window.updateDesigners.remove(designer.handle)}
          >
            <span className="visually-hidden">Unfollow</span>
            {designer.name}
            <svg
              width="7"
              height="8"
              viewBox="0 0 7 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 6.33301L6 1.33301"
                stroke="currentColor"
                stroke-linecap="square"
              />
              <path
                d="M1 1.33301L6 6.33301"
                stroke="currentColor"
                stroke-linecap="square"
              />
            </svg>
          </button>
        </li>
      ))}
    </ul>
  );
}
